import { EntityViewDisplay } from '@jms/model';
import { displayTypeCommand } from '@workbuddy/ui/v2/blocks/settings.panel';

/**
 * Layouts offered to an entity that declares no `supportedDisplays`.
 *
 * Table only. Kanban, Card, List, Calendar, and Attachments are opt-in on the manifest
 * (`board.supportedDisplays`) or the mount (`restrictions.supportedDisplays`). A Kanban with no
 * Column renders the same card grid as Card, so neither is implied by silence.
 */
export const DEFAULT_VIEW_DISPLAY_TYPES: readonly EntityViewDisplay[] = [EntityViewDisplay.Table];

/**
 * Display tabs for the view editor.
 *
 * The current display is always offered, even when it is no longer in the entity's set — a view
 * saved as Card before Card left the default must stay editable, and a tab the editor never paints
 * is a display the user silently loses on the next save.
 */
export function resolveDisplayTypes(supported: readonly EntityViewDisplay[] | null | undefined, current: EntityViewDisplay | null | undefined): EntityViewDisplay[] {

  const types = [...(supported?.length ? supported : DEFAULT_VIEW_DISPLAY_TYPES)];
  if (current && !types.includes(current) && displayTypeCommand(current)) types.push(current);
  return types;
}
